export default __webpack_public_path__ + "static/msi-projects-60eac5d73bf34a612ad5384fba966c22.jpg";